import type { ReactElement } from 'react'
import styled from 'styled-components'

import { BSTable, CFTable, PLTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { AnotationText } from '@/components/layouts/Ir/Mpocket/AnotationText'
import { DownloadButton } from '@/components/layouts/Ir/Mpocket/DownloadButton'

import { useMpocketScript } from '@/hooks/useMpocketScript'

console.log('3')

export const CfsPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-financial-cfs.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-financial-cfs.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Consolidated Financial Statement"
        subTitleText="連結財務諸表"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>ダウンロード（連結PL、BS、CF）</AHeading>
        <Download>
          <DownloadButton id="irp-cfs-pdf" />
          <DownloadButton id="irp-cfs-xls" />
        </Download>
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>連結損益計算書</AHeading>
        <PLTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-pltxt" />
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>連結貸借対照表</AHeading>
        <BSTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-bstxt" />
      </section>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        <AHeading>連結キャッシュ・フロー計算書</AHeading>
        <CFTable />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <AnotationText id="irp-highlight-table-cftxt" />
      </section>
    </Layout>
  )
}

CfsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '業績・財務情報', path: '/ir/financial/' },
    { name: '連結財務諸表', path: '' },
  ]

  return (
    <>
      <Head
        title="連結財務諸表"
        description="トライアルホールディングスグループの連結PL、BS、CFについて掲載しています。"
        ogp={{ url: 'ir/financial/cfs/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
const Download = styled.div`
  display: flex;
  gap: 20px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    gap: 16px;
  }
`
